import {getTestProps} from '@benchling/js-test-utils';
import {Checkbox, createStyles} from '@mantine/core';
import React from 'react';

import {
  isMSAConfigurable,
  type ScientificModelNode,
} from 'model-hub/scientific-models/ScientificModelMetadata';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export interface MSAOptionsProps {
  model: ScientificModelNode;
  msaEnabled: boolean;
  onMSAEnabledChange?: (enabled: boolean) => void;
  className?: string;
}

export default function MSAOptions({
  model,
  msaEnabled,
  onMSAEnabledChange,
  className,
}: MSAOptionsProps): JSX.Element | null {
  const {classes} = useStyles();
  const showNotice = model.capabilities.showMsaRecentlyAddedNotice;

  if (!isMSAConfigurable(model)) {
    return null;
  }

  return (
    <div
      className={`${classes.container} ${className ?? ''}`}
      {...getTestProps({component: 'MSAOptions', element: 'root'})}
    >
      {showNotice && (
        <InlineBanner
          bannerType={InlineBannerType.INFO}
          text={`MSA support is now available for ${model.displayName}. Choose whether to use MSAs.`}
        />
      )}
      <Checkbox
        checked={msaEnabled}
        disabled={onMSAEnabledChange == null}
        label="Use MSAs"
        onChange={(event) => {
          onMSAEnabledChange?.(event.currentTarget.checked);
        }}
      />
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
}));
